import { useEffect, useState } from "react";
import { fetchMyRolePermissions } from "../../../public/api/myRolePermissionsApi";

/**
 * Loads User builder submodule permissions for the logged-in role (JWT).
 */
export function useScheduleRolePermissions(enabled = true) {
  const [permissions, setPermissions] = useState({});
  const [roleSlug, setRoleSlug] = useState("");
  const [loading, setLoading] = useState(Boolean(enabled));
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!enabled) {
      setLoading(false);
      return undefined;
    }

    let cancelled = false;

    (async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await fetchMyRolePermissions();
        if (cancelled) return;
        setPermissions(
          data?.permissions && typeof data.permissions === "object"
            ? data.permissions
            : {},
        );
        setRoleSlug(data?.roleSlug || "");
      } catch (err) {
        if (cancelled) return;
        if (err?.status === 401 || err?.message === "session_timeout") {
          return;
        }
        setPermissions({});
        setRoleSlug("");
        setError(err?.message || "Failed to load permissions");
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return { permissions, roleSlug, loading, error };
}
